import { formatIOSDateStr } from './time';
import { url } from '@tencent/wphk-base-utils';

// mock系统时间
const mockServerTime = url.getUrlParam('serverTime');
// 使用本地时间
const localTime = url.getUrlParam('localTime');
let serverTimeDiff = 0;

/**
 * 设置系统时间
 * @param inputServerTime
 */
export function setServerTime(inputServerTime: string | number) {
  if (serverTimeDiff) return;
  // 如果已赋值就返回
  let serverTime = mockServerTime || inputServerTime;

  if (typeof serverTime === 'string') {
    serverTime = formatIOSDateStr(serverTime);
    // 如果传入的全为数字，说明时时间戳，需要转换成数字类型
    if (/^\d+$/.test(serverTime)) {
      serverTime = parseInt(serverTime, 10);
    }
  }
  serverTimeDiff = Date.now() - new Date(serverTime).getTime();
}

/**
 * 获取系统时间
 * @returns {Date}
 */
export function getServerTime(): Date {
  if (localTime === '1') return new Date();
  return new Date(Date.now() - serverTimeDiff);
}
